import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} viewBox="0 0 29 29" {...props}>
      <g data-name="Group 2410">
        <g data-name="Group 2404">
          <rect
            data-name="Rectangle 835"
            width={29}
            height={29}
            rx={10}
            fill={props.fillSecondary}
          />
        </g>
        <g data-name="Group 2385" fill={props.fillPrimary}>
          <path data-name="Path 27" d="M16.894 10.341h4.765L25 6h-4.506z" />
          <path
            data-name="Path 28"
            d="M10.733 15.977h8.63V18.4h-6.311a6.422 6.422 0 01-1.971-.286 4.808 4.808 0 01-1.559-.814A3.571 3.571 0 018.5 16.04a3.647 3.647 0 01-.364-1.634 3.571 3.571 0 01.375-1.635 4.038 4.038 0 011.036-1.282 4.675 4.675 0 011.562-.849 6.075 6.075 0 011.943-.3h2.369L19.028 6h-5.976a13.209 13.209 0 00-4.015.585 9.577 9.577 0 00-3.181 1.673 7.9 7.9 0 00-2.1 2.593A7.309 7.309 0 003 14.183a7.611 7.611 0 00.759 3.38 8.241 8.241 0 002.1 2.694 9.936 9.936 0 003.181 1.785 12.058 12.058 0 004.015.648H24.5V12.26H13.825z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
